import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import EScriptRequestView from './PomRequestView';

const EScriptOrdersOptions = ({ referenceId, requestId, orderId, mpi, partnerId }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = !!anchorEl;
  const [detailedView, setDetailedView] = useState(false);

  const closeRequestDetailedView = () => setDetailedView(false);
  const openRequestDetailedView = () => {
    setDetailedView(true);
    setAnchorEl(null);
  };

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  return (
    <>
      <IconButton
        id={`EScriptOrdersOptions-${requestId}options-button`}
        aria-label={`OrderStatus options ${requestId}`}
        onClick={handleMenuOpen}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id={`EScriptOrdersOptions-${requestId}options-menu`}
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={openRequestDetailedView}>View</MenuItem>
      </Menu>

      {detailedView && (
        <EScriptRequestView
          open={detailedView}
          requestId={requestId}
          referenceId={referenceId}
          onClose={closeRequestDetailedView}
          orderId={orderId}
          partnerId={partnerId}
          mpi={mpi}
        />
      )}
    </>
  );
};

export default EScriptOrdersOptions;

EScriptOrdersOptions.propTypes = {
  requestId: PropTypes.string.isRequired,
  referenceId: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  mpi: PropTypes.string.isRequired,
  partnerId: PropTypes.string.isRequired,
};
